import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-dark ms-top-bar-color ms-top-bar fixed-top" }
const _hoisted_2 = {
  class: "d-flex align-items-center username",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#offcanvasNavbar",
  "aria-controls": "offcanvasNavbar",
  "aria-label": "Toggle navigation"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "NKT-P3 username-text" }

import { onMounted, ref, watch } from 'vue'
import user from '@/assets/svg/user.svg'
import { requiredInject } from '@/utilities/requiredInject'
import { MSAL } from '@/plugins/msal/msal'
import { useUserStore } from '@/stores/UserStore'
import { UserClient } from '@/server/MakeSenseApp-backend'


export default /*@__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const userName = ref<string>()
const userStore = useUserStore()

const msal = requiredInject<MSAL>('MSAL')
const userClient = requiredInject<UserClient>('UserClient')

function appendRole() {
  if (userStore.isMasterAdmin) {
    return ', Master Admin'
  } else if (userStore.isAdmin) {
    return ', Admin'
  } else if (userStore.isOwnerOrHigher) {
    return ', Owner'
  } else {
    return ''
  }
}

onMounted(() => {
  watch(
    () => userStore.refreshDataCounter,
    () => {
      if (msal.isAuthenticated()) {
        userClient.currentUser().then((user) => {
          userStore.setCurrentUser(user)
          userName.value = user.name
        })
      }
    },
    { immediate: true }
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(user),
        class: "icon"
      }, null, 8, _hoisted_3),
      _createElementVNode("span", _hoisted_4, _toDisplayString(userName.value) + _toDisplayString(appendRole()), 1)
    ])
  ]))
}
}

})